import { useClock } from '../store/clock-store';

export interface DojezdOdpocetStav {
    /** Ma se udaj vubec vykreslit. */
    zobrazit: boolean;
    /** "1:42" pred cilovym casem, "+0:45" po nem. */
    formatted: string;
    /** Cilovy cas uz uplynul — barvit chybove. */
    poCase: boolean;
}

const SKRYTY: DojezdOdpocetStav = { zobrazit: false, formatted: '', poCase: false };

/**
 * Cisty vypocet oddeleny od Reactu, aby sel otestovat na konkretnich casech.
 *
 * Odpocet mizi vsem najednou, jakmile od vyhlaseni uplyne cas vyjezdu jednotky —
 * po vyjeti uz jsou ohlasene dojezdy bezcenne a displej ma zustat citelny.
 */
export function vypoctiDojezd(
    dojezdCas: string | undefined,
    casVyhlaseni: string,
    casVyjezdMinuty: number,
    now: Date,
): DojezdOdpocetStav {
    if (!dojezdCas) return SKRYTY;

    const cutoff = new Date(casVyhlaseni).getTime() + casVyjezdMinuty * 60_000;
    if (now.getTime() >= cutoff) return SKRYTY;

    const zbyva = Math.floor((new Date(dojezdCas).getTime() - now.getTime()) / 1000);
    const poCase = zbyva < 0;
    const abs = Math.abs(zbyva);
    const mins = Math.floor(abs / 60);
    const secs = abs % 60;

    return {
        zobrazit: true,
        poCase,
        // Format se schvalne shoduje s useElapsedTime (hlavni casovac na tez obrazovce):
        // MM:SS s doplnenou nulou v minutach.
        formatted: `${poCase ? '+' : ''}${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`,
    };
}

/**
 * Tik zajistuje sdileny `clock-store` — jeden setInterval pro celou obrazovku,
 * ne vlastni casovac na kazdou ze tricet karet.
 */
export const useDojezdOdpocet = (
    dojezdCas: string | undefined,
    casVyhlaseni: string,
    casVyjezdMinuty: number,
): DojezdOdpocetStav => {
    // Bez useMemo zamerne: `now` je novy Date kazdy tik, takze by memo nikdy netrefilo
    // a pridavalo by jen alokaci deps pole navic — tricetkrat za vterinu na displeji.
    const now = useClock();
    return vypoctiDojezd(dojezdCas, casVyhlaseni, casVyjezdMinuty, now);
};
